import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const nisbetsSignupManagementRoute: RouteConfig<'with-page'> = {
    name: 'Signups',
    path: '/nisbets/signups',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin', 'nisbetsEmployee'],
}